import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import dagre from 'dagre';
import ReactFlow, {
    addEdge,
    Background,
    Controls,
    MiniMap,
    Handle,
} from 'react-flow-renderer';

import { useDataAuth } from '../../../hooks/useDataAuth';
import { useManageComponentFlow } from '../hooks/useManageComponentFlow';
import { useManageUsers } from '../../users/hooks/useManageUsers';
import { useNotification } from '../../../hooks/useNotification';

import { getFunctionsSchema, getSchemes } from '../../../redux/actions/flows';
import { setNotificaction } from '../../../redux/actions/users';

import { EditItemToolbar } from '../../../components/editItem/EditItemToolbar';
import FlowEditor from './FlowEditor';
import { CreateComponent } from './../detailsComponentFlow/CreateComponent';
import { DetailsExecutionLog } from '../../../components/flows/DetailsExecutionLog';
import OptionsMenu from './OptionsMenu';

import { getIconByType } from '../utils/getIconByType';
import { ensureJsonObject } from '../../../utils/validateResponseApi';
import { getProperty, safeParseJSON, safeStringifyJSON, validateAndEnsureArray } from '../../../utils/jsonValidator';

export const DetailsFlow = ({ flowManager }) => {
    const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW;
    const [fatherIconState, setFatherIconState] = useState({});
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [sendNotification] = useNotification();
    const {
        updatingFlows: isUpdatingFlows,
        deletingFlows: isDeletingFlows,
        listSchemes,
        listFunctionsSchema,
        isChangeDataFlows,
        flowInEdition,
        dataLog,
        handleDeleteFlow,
        handleChangeFlow,
        getDataFlow,
        setValeComponentFlowInEdition,
        updateFlow,
        getFlowLog
    } = flowManager;

    const [UsersManager] = useManageUsers();
    const {
        isNotification,
        msg,
        typeMsg,
    } = UsersManager;

    const [openModalCreateCF, setOpenModalCreateCF] = useState(false);
    const { orders, typeAction, itemEditComponentFlow, handleCreateComponetFlow,
        handleAddComponetFlow, handleDeleteSubComponet,
        handleUpdateBodyComponetFlow, handleEditComponet, getImputValid
    } = useManageComponentFlow(
        flowInEdition,
        setOpenModalCreateCF,
        setValeComponentFlowInEdition,
    );

    useEffect(() => {
        if (isNotification) {
            sendNotification({ msg: msg, variant: typeMsg });
            dispatch(setNotificaction({}));
        }
    }, [isNotification, msg, typeMsg, dispatch, sendNotification]);

    const [isLoadingFlows] = useState(false);
    const [{ userSession }] = useDataAuth();

    const [isLogDetails, setIsLogDetails] = useState(false);
    const [openModalLog, setOpenModalLog] = useState(false);
    const [detailLog, setDetailLog] = useState({});

    const setDataDetails = (item) => {
        setOpenModalLog(true);
        const objst = dataLog.ComponentMap.find(s => s.Order === item.order);
        const obj = {
            exit: safeParseJSON(objst?.Result),
            entry: safeParseJSON(objst?.Body)
        }
        setDetailLog(safeStringifyJSON(obj));
    }

    useEffect(() => {
        if (location.state && location.state.config) {
            const { id, data } = location.state.config || {};
            if (data?.id_flow_log) {
                setIsLogDetails(true);
                getFlowLog(id, data?.id_flow);
            }
            else {
                dispatch(getDataFlow(id, userSession.token));
            }
        }
        setIsInitiallyCentered(false);
        setNodes([]);
        setEdges([]);
    }, []);

    const handleClickDeleteFlow = () => {
        handleDeleteFlow(flowInEdition.id_flow)
        setTimeout(() => {
            navigate(-1);
        }, 500);
    }

    const [itemEdit, setItemEdit] = useState({});
    const [scheme, setEscheme] = useState([]);
    const [openModalEdit, setOpenModalEdit] = useState(false);
    function handleEditBodyComponent(item) {
        setItemEdit(item);
        setOpenModalEdit(true);
        const sch = listSchemes.find(s => s.type_component === item.type_component);
        const jsonSchema = getProperty(sch, 'json_schema') || [];
        setEscheme(validateAndEnsureArray(jsonSchema));
    }

    useEffect(() => {
        if (listSchemes.length === 0)
            dispatch(getSchemes(userSession.token));
        if (listFunctionsSchema.length === 0)
            dispatch(getFunctionsSchema(userSession.token));
    }, []);

    //#region work-flow
    const dagreGraph = new dagre.graphlib.Graph();
    dagreGraph.setDefaultEdgeLabel(() => ({}));
    const nodeWidth = 310;
    const nodeHeight = 36;

    const [nodes, setNodes] = useState([]);
    const [edges, setEdges] = useState([]);
    const [nodesHide, setNodesHide] = useState([]);
    const [flashNode, setFlashNode] = useState(null);
    const [reactFlowInstance, setReactFlowInstance] = useState(null);
    const [isInitiallyCentered, setIsInitiallyCentered] = useState(false);

    const getLayoutedElements = (nodes, edges, direction = 'LR') => {
        const isHorizontal = direction === 'LR';
        dagreGraph.setGraph({ rankdir: direction });

        nodes.forEach((node) => {
            dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
        });

        edges.forEach((edge) => {
            dagreGraph.setEdge(edge.source, edge.target);
        });

        dagre.layout(dagreGraph);

        nodes.forEach((node) => {
            const nodeWithPosition = dagreGraph.node(node.id);
            node.targetPosition = isHorizontal ? 'left' : 'top';
            node.sourcePosition = isHorizontal ? 'right' : 'bottom';
            node.position = {
                x: nodeWithPosition.x - nodeWidth / 2,
                y: nodeWithPosition.y - nodeHeight / 2,
            };
        });

        return { nodes, edges };
    };

    const MyOptionsMenu = (data, nodeType, father, order) => (
        <OptionsMenu
            data={data}
            ord={order}
            nodeType={nodeType}
            father={father}
            log={isLogDetails}
            fatherIconState={fatherIconState}
            dataLog={dataLog}
            setDataDetails={setDataDetails}
            setOpenModalLog={setOpenModalLog}
            setDetailLog={setDetailLog}
            handleCreate={handleCreateComponetFlow}
            handleEditBodyComponent={handleEditBodyComponent}
            handleEditComponet={handleEditComponet}
            handleDeleteSubComponet={handleDeleteSubComponet}
            HideNodes={HideNodes}
        />
    );

    const DecisionNode = ({ data }) => {
        const { isFather } = data;
        return (
            <div className="decisionNode">
                <Handle type="target" position="left" style={{ left: 0, top: '50%', background: 'gray' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {getIconByType(data.type_component)}
                    <span style={{ marginLeft: 8, marginRight: 8, fontSize: 12 }} >{data.label}</span>
                    {MyOptionsMenu(data, 'DEC', isFather, data.order)}
                </div>
                <Handle type="source" position="right" id="true" style={{ right: 1, top: '95%', background: 'green' }} />
                <Handle type="source" position="right" id="false" style={{ right: 1, top: '5%', background: 'red' }} />
            </div>
        );
    };

    const CustomNodeWithEdit = ({ data }) => {
        const { isFather } = data;
        const iconState = fatherIconState[data.order];
        const customClassName = `
            ${isFather && iconState ? 'highlightNode' : ''}
            ${flashNode === data.order ? 'flash' : ''}
        `;

        return (
            <div className={customClassName}
                style={{ maxWidth: 300, padding: 3, backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: 5, whiteSpace: 'pre-wrap' }}
            >
                <Handle type="target" position="left" style={{ background: '#555' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {getIconByType(data.type_component)}
                    <span style={{ marginLeft: 8, marginRight: 8, fontSize: 12 }} >{data.label}</span>
                    {MyOptionsMenu(data, 'CUSTOM', isFather, data.order)}
                </div>
                <Handle type="source" position="right" id="regular" style={{ background: '#555' }} />
            </div>
        );
    };

    const NodeRoot = ({ data }) => {
        return (
            <div className='nodeRoot'>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ marginLeft: 8, marginRight: 8, fontSize: 12 }} >{data.label}</span>
                    {MyOptionsMenu(data, 'ROOT', false, "")}
                </div>
                <Handle type="source" position="right" id="regular" style={{ background: '#555' }} />
            </div>
        );
    };

    const nodeTypes = {
        customNodeWithEdit: CustomNodeWithEdit,
        customNodeDecision: DecisionNode,
        customNodeRoot: NodeRoot
    };

    const getParentOrder = (order) => {
        const parts = order.split('.');

        if (parts.length > 1 && (parts[parts.length - 2] === '0' || parts[parts.length - 2] === '1')) {
            const lastPart = parts[parts.length - 2];
            const parentId = parts.slice(0, -2).join('.');
            const branchType = lastPart === '1' ? 'true' : 'false';

            return { parentId, branchType };
        }

        const lastPart = parts[parts.length - 2];
        // const parentId = parts.slice(0, -1).join('.');
        const branchType = lastPart === '1' ? 'true' : 'false';

        return { parentId: parts.slice(0, -1).join('.'), branchType: branchType };
    };

    const generateFlowElements = (data, name) => {
        const nodes = [];
        const edges = [];

        nodes.push({
            id: '00',
            data: { label: name, type_component: 'root' },
            position: { x: 0, y: 0 },
            type: 'customNodeRoot',
            sourcePosition: 'right',
            targetPosition: 'left',
        });

        if (!data.flow_component || data.flow_component.length === 0) {
            return { nodes, edges };
        }

        data.flow_component.forEach((itemComponent) => {
            const { type_component, description, order, subtype_component, input } = itemComponent;

            const nodeId = itemComponent.order;
            const children = data.flow_component.filter(child => child.order.startsWith(nodeId + "."));
            const hasChildren = children.length > 0;

            const formattedLabel = [
                [order, type_component, subtype_component, input].filter(Boolean).join(' - '), // First line
                [description].filter(Boolean).join(' '),
            ].join('\n');

            nodes.push({
                id: order,
                data: { label: formattedLabel, ...itemComponent, isFather: hasChildren, },
                position: { x: 0, y: 0 },
                type: type_component === "decision" ? 'customNodeDecision' : 'customNodeWithEdit',
                sourcePosition: 'right',
                targetPosition: 'left',
            });

            if (!order.includes('.')) {
                edges.push({
                    id: `e00-${order}`,
                    source: '00',
                    target: order,
                });
            }

            const { parentId, branchType } = getParentOrder(order);
            const parentNode = nodes.find(node => node.id === parentId);
            const isDecisionNode = parentNode?.data?.type_component === 'decision';

            const edgeColor = isDecisionNode
                ? (branchType === 'true' ? 'green' : 'red')
                : 'grey';

            if (parentId) {
                edges.push({
                    id: `e${parentId}-${order}`,
                    source: parentId,
                    target: order,
                    sourceHandle: branchType,
                    style: { stroke: edgeColor, strokeWidth: 0.5 },
                });
            }

        });

        return { nodes, edges };
    };

    function HideNodes(node) {
        const nodes = [];
        const edges = [];
        let array = [];
        let nodeHidden = `${node}.`;

        const isShowingChildren = nodesHide.includes(nodeHidden);

        if (isShowingChildren) {
            setFlashNode(node);
            setTimeout(() => setFlashNode(null), 800);
        }

        const isIncluded = nodesHide.includes(nodeHidden);
        if (isIncluded) {
            array = nodesHide.filter((p) => p !== nodeHidden);
            setNodesHide(nodesHide.filter((p) => p !== nodeHidden));
        }
        else {
            array = nodesHide;
            array.push(nodeHidden);
            setNodesHide((noHide) => [
                ...noHide,
                nodeHidden
            ]);
        }

        nodes.push({
            id: '00',
            data: { label: `${flowInEdition?.name}`, type_component: 'root' },
            position: { x: 0, y: 0 },
            type: 'input',
            sourcePosition: 'right',
            targetPosition: 'left',
        });

        const data = JSON.parse(flowInEdition.component);
        data.flow_component.forEach((itemComponent) => {
            const { type_component, description, order, subtype_component, input } = itemComponent;
            const formattedLabel = [
                [order, type_component, subtype_component, input].filter(Boolean).join(' - '), // First line
                [description].filter(Boolean).join(' '),
            ].join('\n');

            const nodeId = itemComponent.order;
            const children = data.flow_component.filter(child => child.order.startsWith(nodeId + "."));
            const hasChildren = children.length > 0;
            if (nodeId === node && hasChildren) {
                setFatherIconState(prevState => ({
                    ...prevState,
                    [node]: !prevState[node]
                }));
            }

            let itemHidden = false;
            array.some((item) => {
                if (order.includes(item)) {
                    itemHidden = true;
                    return true;
                } else if (order.startsWith(item)) {
                    itemHidden = true;
                    return true;
                }
                else {
                    itemHidden = false;
                    return false;
                }
            });

            nodes.push({
                id: order,
                data: { label: formattedLabel, ...itemComponent, isFather: hasChildren, hidden: itemHidden, },
                position: { x: 0, y: 0 },
                type: type_component === "decision" ? 'customNodeDecision' : 'customNodeWithEdit',
                sourcePosition: 'right',
                targetPosition: 'left',
                hidden: itemHidden,
            });

            if (!order.includes('.')) {
                edges.push({
                    id: `e00-${order}`,
                    source: '00',
                    target: order,
                });
            }

            const { parentId, branchType } = getParentOrder(order);
            const parentNode = nodes.find(node => node.id === parentId);
            const isDecisionNode = parentNode?.data?.type_component === 'decision';

            const edgeColor = isDecisionNode
                ? (branchType === 'true' ? 'green' : 'red')
                : 'grey';

            if (parentId) {
                edges.push({
                    id: `e${parentId}-${order}`,
                    source: parentId,
                    target: order,
                    sourceHandle: branchType,
                    style: { stroke: edgeColor, strokeWidth: 0.5 },
                    hidden: itemHidden
                });
            }
        });

        const visibleNodes = nodes.filter(node => !node.hidden);
        const visibleEdges = edges.filter(edge => !edge.hidden);
        const { nodes: layoutedNodes, edges: layoutedEdges } = getLayoutedElements(visibleNodes, visibleEdges);

        setNodes(layoutedNodes);
        setEdges(layoutedEdges);

        const clickedNode = nodes.find(n => n.id === node);
        if (clickedNode) {
            const { x, y } = clickedNode.position;
            if (reactFlowInstance) {
                reactFlowInstance.setCenter(x, y, { zoom: 0.9, duration: 500 });
            }
        }
    }

    useEffect(() => {
        if (flowInEdition?.component) {
            const { nodes: generatedNodes, edges: generatedEdges } = generateFlowElements(ensureJsonObject(flowInEdition.component), flowInEdition.name + ' ' + flowInEdition.id_unique);
            const { nodes: layoutedNodes, edges: layoutedEdges } = getLayoutedElements(generatedNodes, generatedEdges);
            setNodes(layoutedNodes);
            setEdges(layoutedEdges);
        }
    }, [flowInEdition]);

    const containerRef = useRef();

    useEffect(() => {
        if (!isInitiallyCentered) {
            if (reactFlowInstance && nodes.length > 0) {
                const initialRootNode = nodes.find(n => n.id === '00');
                if (initialRootNode) {
                    const { x, y } = initialRootNode.position;
                    const nodeWidth = 310;
                    const nodeHeight = 36;

                    if (containerRef.current && x !== undefined && y !== undefined) {
                        const viewportWidth = containerRef.current.clientWidth;
                        const viewportHeight = containerRef.current.clientHeight;
                        const adjustedX = x - viewportWidth / 6 + nodeWidth / 2;
                        const adjustedY = y - viewportHeight / 2 + nodeHeight / 2;
                        setTimeout(() => {
                            reactFlowInstance.setViewport({ x: -adjustedX, y: -adjustedY, zoom: 0.9 }, { duration: 500 });
                            setIsInitiallyCentered(true);
                        }, 500);
                    }
                }
            }
        }
    }, [reactFlowInstance, nodes, isInitiallyCentered, containerRef]);

    const onConnect = useCallback((params) => setEdges((eds) => addEdge(params, eds)), []);
    //#endregion

    return (
        <>
            <Box ref={containerRef} sx={{ height: '85vh', display: 'flex', flexDirection: 'column' }}>
                <Grid container sx={{ mb: 2, flexShrink: 0 }}>
                    <EditItemToolbar
                        isLoadingItems={isLoadingFlows}
                        titleEditItem={{
                            label: `Id Flow: ${flowInEdition?.id_flow} / `,
                            name: 'name',
                            value: flowInEdition?.name,
                            handleChange: handleChangeFlow,
                            isEditable: true
                        }}
                        nameItem={"Flow"}
                        isSaving={isUpdatingFlows}
                        statusButtonSave={isChangeDataFlows}
                        isDeleting={isDeletingFlows}
                        handleSaveChanges={updateFlow}
                        statusButtonDelete={true}
                        isLogDetails={isLogDetails}
                        handleClickDelete={handleClickDeleteFlow}

                    />
                </Grid>

                <Grid container style={{ display: "flex", alignItems: "stretch", flex: 1, overflow: 'hidden' }}>
                    <Grid size={{ md: 12 }} elevation={4} style={{ overflow: 'hidden', padding: 20, flex: 1 }}>
                        <Box sx={{ height: '100%' }}>
                            <div style={{ height: '100%', minHeight: 400 }}>
                                <ReactFlow
                                    nodes={nodes}
                                    edges={edges}
                                    nodeTypes={nodeTypes}
                                    deleteKeyCode={46}
                                    onInit={(instance) => setReactFlowInstance(instance)}
                                >
                                    <MiniMap />
                                    <Controls />
                                    <Background color="#aaa" gap={16} />
                                </ReactFlow>
                            </div>
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            {
                openModalEdit &&
                <FlowEditor
                    open={openModalEdit}
                    data={itemEdit}
                    scheme={scheme}
                    setOpen={setOpenModalEdit}
                    handleSave={handleUpdateBodyComponetFlow}
                />
            }

            {
                openModalCreateCF &&
                <CreateComponent
                    flowManager={flowManager}
                    data={itemEditComponentFlow}
                    orders={orders}
                    typeAction={typeAction}
                    open={openModalCreateCF}
                    setOpen={setOpenModalCreateCF}
                    onSave={handleAddComponetFlow}
                    getImputValid={getImputValid}
                />
            }

            {
                openModalLog &&
                <DetailsExecutionLog
                    open={openModalLog}
                    data={detailLog}
                    setOpen={setOpenModalLog}
                />
            }
        </>
    )
}